var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/mode-mysql';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-r';
import 'ace-builds/src-noconflict/ext-language_tools';
import './BaseCodeEditor.css';
const BaseCodeEditor = forwardRef((_a, ref) => {
    var { className = '', editorProps, autocomplete } = _a, rest = __rest(_a, ["className", "editorProps", "autocomplete"]);
    // Turn off certain features of ace-editor which are enabled by default and which we don't use, as users invoke them (possibly unintentionally) by the default keybindings lead to errors. These errors manifest in Sentry as:
    // Unexpected token '<'
    // and the missing module, for example `coding/ext-prompt`
    const aceEditorRef = useRef(null);
    useImperativeHandle(ref, () => ({
        getSelectedText() {
            var _a;
            return (_a = aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor.getSelectedText();
        },
        focus() {
            var _a;
            return (_a = aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor.focus();
        },
        increaseFontSize() {
            var _a, _b;
            return (_a = aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor.setFontSize(`${parseFloat((_b = aceEditorRef.current) === null || _b === void 0 ? void 0 : _b.editor.getFontSize().toString().slice(0, -3)) + 0.1}rem`);
        },
        decreaseFontSize() {
            var _a, _b;
            return (_a = aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor.setFontSize(`${parseFloat((_b = aceEditorRef.current) === null || _b === void 0 ? void 0 : _b.editor.getFontSize().toString().slice(0, -3)) - 0.1}rem`);
        },
        getFontSize() {
            var _a;
            return (((_a = aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor.getFontSize().toString()) || '0.8125rem');
        },
        setFontSize(size) {
            var _a;
            return (_a = aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor.setFontSize(size);
        },
    }));
    useEffect(() => {
        if (!aceEditorRef.current)
            return;
        aceEditorRef.current.editor.commands.removeCommand('find');
        aceEditorRef.current.editor.commands.removeCommand('replace');
        aceEditorRef.current.editor.commands.removeCommand('showSettingsMenu');
        aceEditorRef.current.editor.commands.removeCommand('gotoline');
        aceEditorRef.current.editor.commands.removeCommand('openCommandPallete');
    }, []);
    return (_jsx(AceEditor, Object.assign({ className: `BaseCodeEditor ${className}`, ref: aceEditorRef, height: "100%", width: "100%", enableLiveAutocompletion: autocomplete, fontSize: "0.8125rem", editorProps: Object.assign(Object.assign({}, editorProps), { $blockScrolling: true }), showPrintMargin: false, wrapEnabled: true, theme: "github" }, rest)));
});
BaseCodeEditor.defaultProps = {
    autocomplete: false,
    fontSizeChange: false,
};
export default BaseCodeEditor;
//# sourceMappingURL=BaseCodeEditor.js.map